export default "__VITE_ASSET__DilK6E4y__"